export default __webpack_public_path__ + "static/media/aboutBgDec4.c0452395.png";